import { Button, Grid, TextField, MenuItem } from "@mui/material";
import { useContext } from "react";
import { customersContext } from '../CustomersContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { Autocomplete, FilterContainer } from "components";

let Filter = () => {

    let service = useContext(customersContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item>
                <TextField
                    label="Nome"
                    size="small"
                    variant="standard"
                    value={service.search.name}
                    onChange={(e: any) => service.updateSearch({ ...service.search, name: e.target.value })}
                />
            </Grid>
            <Grid item>
                <TextField
                    label="Email"
                    size="small"
                    variant="standard"
                    value={service.search.email}
                    onChange={(e: any) => service.updateSearch({ ...service.search, email: e.target.value })}
                />
            </Grid>
            <Grid item>
                <Autocomplete
                    inputLabel="Cliente"
                    variant="standard"
                    value={{
                        value: service.search.customerId,
                        label: service.search.customerName
                    }}
                    doSearch={(value: string, etag: number) => service.searchCustomerCompanies(value, etag)}
                    onChange={(value: any) => {
                        service.updateSearch({
                            ...service.search,
                            customerId: value?.value || 0,
                            customerName: value?.customerName || ''
                        });
                    }}
                />
            </Grid>
            <Grid item>
                <TextField
                    select
                    label="Visualizza solo"
                    size="small"
                    variant="standard"
                    value={service.search.showOnly}
                    onChange={(e: any) => service.updateSearch({ ...service.search, showOnly: e.target.value })}
                >
                    <MenuItem value="active">Clienti attivi</MenuItem>
                    <MenuItem value="deleted">Clienti non attivi</MenuItem>
                </TextField>
            </Grid>
            <Grid item>
                <Button
                    type="submit"
                    color="secondary"
                    variant="outlined"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;